import { Component, Input } from '@angular/core';

@Component({
  selector: '[appFormColumn]', // tslint:disable-line:component-selector
  templateUrl: './form-column.component.html',
  styleUrls: ['./form-column.component.css']
})
export class FormColumnComponent {
  @Input() title: string;
  @Input() icon: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/tables/form-table/form-column/form-column.component.ts